import {Pipe, PipeTransform} from '@angular/core';

interface IPaginationData {
  currentPage: number;
  itemsPerPage: number;
}

@Pipe({
    name: 'pagination',
    pure: false,
    standalone: false
})
export class PaginationPipe implements PipeTransform {

  transform<T>(items: T[], paginationData: IPaginationData): T[] {

      const {currentPage, itemsPerPage} = paginationData;
      let start = (currentPage - 1) * itemsPerPage;
      if (start < 0) {
          start = 0;
      }

      const end = start + itemsPerPage - 1;
      const pageItems: T[] = [];

      for (let i = start; i <= end; i++) {
          if (items[i]) {
              pageItems.push(items[i]);
          }
      }

      return pageItems;
  }

}
